export default "__VITE_ASSET__C7Me9Iu3__"